<template>
  <div>
    <div>
      <TopNotification
        class="topNotification"
        v-if="showBanner"
        @closeNotification="showBanner = false"
      />
    </div>
    <div class="toolbar">
      <div class="go-left">
        <div class="r-logo" :id="`title-icon-${app.currentSideNav.icon}`">
          <BaseIcon
            :name="app.currentSideNav.icon"
            width="1.875em"
            height="1.875em"
          />
        </div>
        <span class="tab-name" :id="`title-text-${app.currentSideNav.icon}`">
          <span> {{ currSidenavMapper(app.currentSideNav.name) }} </span>
        </span>
      </div>
      <LanguageSelectField class="lang-comp" />
      <div v-if="!disableDoc" class="docs-view">
        <RexButton
          class="docs-view"
          variant="secondary"
          id="view-doc-btn"
          :styling="{}"
          @onClick="openPage"
        >
          {{ $t('documentation') }}
        </RexButton>
      </div>
      <div :class="{ dateBoxHidden: isRouteDatePicker }">
        <RexRefresh
          v-if="!isRoute"
          id="ref-dropdown"
          :current="dropDown"
          :options="refOptions"
          :disableAutoRefresh="disableRef"
          @input="handleAuto"
          @reload="debouncedHandleReload"
          :disableAutoRefreshTimer="disableAutoRefreshTimer"
        />
      </div>
      <div v-if="!isRoute && !isRouteDatePicker" class="date-box">
        <RexDatePicker
          :options="timeSelectOptions"
          :enableIcon="true"
          :iconDetails="{
            iconName: 'calendarDuration',
            iconWidth: '1.125rem',
            iconHeight: '1.125rem',
          }"
          :duration="time"
          @input="onTimeChange"
          @custom="setCustomDuration"
          @disableAutoRef="(val) => (customWindowOpen = val)"
          :selectedTimeLabel="selectedTime"
          :key="dateOptionsKey"
        />
      </div>
      <div class="compare-date" v-if="iscompareDuration">
        <div :class="{ 'disabled-overlay': !isCompareCalendarEnabled }">
          <RexCompareDatePicker
            :options="timeSelectOptions"
            :duration="compareTime"
            :iconDetails="{
              iconName: 'calendarDuration',
              iconWidth: '1.125rem',
              iconHeight: '1.125rem',
            }"
            :selectedTimeLabel="selectedTime"
            @compareCustom="setCompareCustomDuration"
          />
          <div v-if="!isCompareCalendarEnabled" class="overlay"></div>
        </div>
      </div>
      <NotificationBtn
        v-if="isNotificationPresent"
        @openNotification="showDialogBox = true"
      />
    </div>
    <DialogBoxNotification
      v-if="showDialogBox"
      @closeDialogBox="showDialogBox = false"
      :notificationMessageList="notificationMessageList"
      :loading="loading"
    />
  </div>
</template>
<script>
import BaseIcon from '../../rex-components/BaseIcon.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import RexDatePicker from '@/rex-components/rex-date-picker-v2.vue';
import LanguageSelectField from '@/components/Main/LanguageSelectField.vue';
import timeFormat from '@/utils/time/timeFormat';
import { DEFAULT_REF_INTERVAL, AUTO_REF_KEY } from '@/utils/constants';
import RexRefresh from '@/rex-components/rex-refresh.vue';
import RexButton from '@/rex-components/rex-button.vue';
import {
  toolbarTimeOptions,
  autoRefTimers,
  timeLabels,
  docs,
  codeProfileRouteBasedCalConfig,
  currSidenavMapper,
} from './main.config';
import TopNotification from '@/components/Main/Notificationfeatures/TopNotification.vue';
import NotificationBtn from '@/components/Main/Notificationfeatures/notificationButton.vue';
import DialogBoxNotification from '@/components/Main/Notificationfeatures/dialogBoxNotification.vue';
import graphQl from '@/services/graphQl';
import BuildConfig from '@/environment';
import debounce from 'lodash/debounce';
import { CAPABILITY_DE } from '@/utils/constants';
import RexCompareDatePicker from '@/rex-components/rex-compare-date-picker.vue';
import { useTime } from '@/hooks/useTime';

const { setDurationFromRoute, setCompareDurationTime } = useTime();

export default {
  components: {
    BaseIcon,
    RexDatePicker,
    RexRefresh,
    TopNotification,
    NotificationBtn,
    DialogBoxNotification,
    RexButton,
    RexCompareDatePicker,
    LanguageSelectField,
  },
  data: function () {
    return {
      auto: false,
      autoTime: DEFAULT_REF_INTERVAL,
      timer: null,
      toggleLabels: [
        this.$t('autoRefreshOffText'),
        this.$t('autoRefreshOnText'),
      ],
      switched: false,
      autoRef: {
        ref: false,
        refInterval: DEFAULT_REF_INTERVAL,
      },
      disableOnPage: ['trace', 'profile'],
      disableDatePicker: [
        'allGroups',
        'configuredV2',
        'tagGroupingV2',
        'secretManagerDashboard',
        'tokenManagerDashboard',
        'allGroupsPage',
        'usageDashboard',
        'extTagGroupingV2',
      ],
      dropDown: { label: DEFAULT_REF_INTERVAL, id: DEFAULT_REF_INTERVAL },
      refOptions: autoRefTimers,
      customWindowOpen: false,
      showBanner: true,
      showDialogBox: false,
      notificationMessageList: [],
      loading: false,
      dateOptionsKey: 0,
      disableAutoRefeshList: ['logPage', 'usageDashboard', 'analyticsPage'],
      isRouteDoc: false,
      selectedCalOption: null,
    };
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  },
  async created() {
    try {
      this.autoRef = JSON.parse(localStorage.getItem(AUTO_REF_KEY));
    } catch (error) {
      //Todo: add error handler
    } finally {
      if (!this.autoRef) await this.setAutoRefConfig();
      let selectedOption = this.refOptions.find(
        ({ id }) => id === this.autoRef.refInterval,
      );
      this.dropDown = selectedOption || this.dropDown;
    }
  },
  methods: {
    ...mapActions('globalState/settings', ['setDuration', 'setCurrTimeLabel']),
    ...mapMutations('globalState/app', ['setIsForcastEnabled']),
    ...mapMutations('globalState/settings', [
      'setCompareDuration',
      'setIsCompareOptionsSelected',
      'setDisablePrevious',
    ]),
    ...mapState('globalState/app', ['customRange']),
    currSidenavMapper,
    async setAutoRefConfig() {
      this.autoRef = {
        ref: this.dropDown.id !== DEFAULT_REF_INTERVAL,
        refInterval: this.dropDown.id,
      };
      localStorage.setItem(AUTO_REF_KEY, JSON.stringify(this.autoRef));
    },
    onVisibilityChange() {
      if (document.hidden) {
        clearInterval(this.timer);
        this.switched = true;
      } else {
        if (this.switched) {
          this.handleAuto(this.dropDown);
          this.switched = false;
        }
      }
    },
    changeDurationBasedForcast() {
      this.onTimeChange(toolbarTimeOptions[3]);
    },
    handleAuto(val) {
      this.dropDown = val;
      this.auto = val.id !== DEFAULT_REF_INTERVAL;
      this.autoTime = val.id;
      this.setAutoRefConfig();
      if (this.auto && !this.disableAutoRefreshTimer) {
        if (this.timer) clearInterval(this.timer);
        this.handleReload();
        this.timer = setInterval(this.handleReload, this.autoTime * 1000);
        document.addEventListener(
          'visibilitychange',
          this.onVisibilityChange,
          false,
        );
      } else {
        document.removeEventListener(
          'visibilitychange',
          this.onVisibilityChange,
        );
        clearInterval(this.timer);
      }
    },
    handleReload() {
      if (!this.disableRef) {
        const gap =
          this.durationShow.end.getTime() - this.durationShow.start.getTime();
        const utcCopy = this.settings.timezoneoffset;
        const time = [new Date(new Date().getTime() - gap), new Date()];
        this.setDuration(timeFormat(time));
        setCompareDurationTime();
      }
    },
    onTimeChange(option) {
      this.setDisablePrevious(false);
      this.selectedCalOption = option;
      const startDate = new Date();
      startDate.setTime(startDate.getTime() - option.value);
      const time = [startDate, new Date()];
      this.setDuration(timeFormat(time));
      this.setCurrTimeLabel(option.name);
      if (
        this.isForcastEnabled &&
        this.getCurrTimeLabel !== timeLabels.oneHour
      ) {
        this.setIsForcastEnabled(!this.isForcastEnabled);
      }
      if (this.isCompareCustom) {
        setCompareCustomDuration(new Date(this.getCompareDurationRow.start));
      } else {
        setCompareDurationTime();
      }
    },
    openPage() {
      window.open(docs[this.app.currentSideNav.icon], '_blank');
    },
    async getDatafordialogBox() {
      try {
        this.loading = true;
        const { data } = await graphQl
          .query('querynotificationtime')
          .params({});
        this.notificationMessageList = data.data.response;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.notificationMessageList = [];
        this.loading = false;
      }
    },
    debouncedHandleReload: debounce(function () {
      this.handleReload();
    }, 300),
    changeCalCodeProfilerBased() {
      if (this.$route.query.startAt && this.$route.query.endAt) {
        const { startAt, endAt } = this.$route.query;
        this.setCustomDuration([
          new Date(parseInt(startAt)),
          new Date(parseInt(endAt)),
        ]);
      } else {
        const { routes, value } = codeProfileRouteBasedCalConfig;
        const { name: currentRouteName } = this.$route;

        if (
          routes.includes(currentRouteName) &&
          (!this?.selectedCalOption?.value ||
            this?.selectedCalOption?.value > value)
        ) {
          this.onTimeChange(toolbarTimeOptions[1]);
        }
      }
    },
    setCustomDuration(range) {
      const { setCustomDuration: hookSetCustomDuration } = useTime();
      hookSetCustomDuration(range);
    },
    setCompareCustomDuration(startDate) {
      const { setCustomDuration: hookSetCompareCustomDuration } = useTime();
      hookSetCompareCustomDuration(startDate);
    },
  },
  computed: {
    // a computed getter
    ...mapState('globalState', ['app', 'settings']),
    ...mapState('globalState/app', ['currentCapability']),
    ...mapState('deState', ['currentDeTab']),
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'durationShow',
      'intervalTime',
      'getCurrTimeLabel',
      'compareDurationShow',
      'getCompareDurationTime',
      'compareDuration',
      'getCompareDurationRow',
    ]),
    ...mapState('globalState/settings', ['isCompareCustom']),
    ...mapState('globalState/app', ['isCompareCalendarEnabled', 'openMenu']),
    isForcastEnabled() {
      return this.app.isForcastEnabled;
    },
    disableRef() {
      const { isCustomDuration } = useTime();

      return (
        this.disableOnPage.includes(this.$route.name) ||
        (isCustomDuration.value && !this.isRouteDatePicker) ||
        this.customWindowOpen
      );
    },
    isRoute() {
      if (this.app.currentSideNav.name == 'Settings') {
        return true;
      } else if (
        this.currentCapability === CAPABILITY_DE &&
        this.currentDeTab.includes('retention')
      ) {
        return true;
      } else if (this.$route.fullPath.includes('licenseUsage')) {
        return true;
      }
      return false;
    },
    hideBrandName() {
      return BuildConfig.VUE_APP_DISABLE_ICON === 'true';
    },
    isRouteDatePicker() {
      return (
        this.disableDatePicker.includes(this.$route.name) ||
        this.$route.path.includes('usages') ||
        this.app?.hideDateTimePicker
      );
    },
    selectedTime() {
      const { selectedTime: computedTime } = useTime();
      return computedTime.value;
    },
    timeSelectOptions() {
      const { timeSelectOptions: computedTimeSelectOptions } = useTime();
      return computedTimeSelectOptions.value;
    },
    time: {
      get() {
        const that = this;
        return [that.durationShow.start, that.durationShow.end];
      },
      set(val) {
        const that = this;
        that.setDuration(timeFormat(val));
        // that.$store.dispatch('SET_DURATION', timeFormat(val));
      },
    },
    compareTime: {
      get() {
        return [this.compareDurationShow.start, this.compareDurationShow.end];
      },
      set(val) {
        this.setCompareDuration(timeFormat(val));
      },
    },
    isNotificationPresent() {
      return this.notificationMessageList?.length > 0;
    },
    disableAutoRefreshTimer() {
      return (
        this.disableAutoRefeshList.includes(this.$route.name) ||
        this.$route.path.includes('usages')
      );
    },
    disableDoc() {
      const disableDocCaps =
        BuildConfig?.VUE_APP_DISABLE_DOC_CAPABILITIES ?? '';
      const isDisableDoc = disableDocCaps
        ?.split(',')
        .includes(this.app.currentSideNav?.key);
      return isDisableDoc || this.hideBrandName;
    },
    iscompareDuration() {
      if (
        (this.app.currentSideNav.key === 'apm' &&
          !codeProfileRouteBasedCalConfig.routes.includes(this.$route.name)) ||
        this.app.currentSideNav.key === 'browser' ||
        this.app.currentSideNav.key === 'mobile' ||
        this.app.currentSideNav.key === 'vm' ||
        this.app.currentSideNav.key === 'k8m' ||
        false
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getDatafordialogBox();
  },
  watch: {
    disableRef: function (newValue, oldValue) {
      if (this.auto)
        newValue ? clearInterval(this.timer) : this.handleAuto(this.dropDown);
    },
    timeSelectOptions: {
      handler() {
        this.dateOptionsKey += 1;
      },
      deep: true,
    },
    disableAutoRefreshTimer: function (newValue, oldValue) {
      if (this.auto)
        newValue ? clearInterval(this.timer) : this.handleAuto(this.dropDown);
    },
    isForcastEnabled: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          this.changeDurationBasedForcast();
        }
      },
    },
    $route: {
      immediate: true,
      handler: function () {
        this.changeCalCodeProfilerBased();
      },
    },
    isCompareCustom(newValue) {
      if (newValue === false) {
        setCompareDurationTime();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.go-left {
  @include flex-center-justify(space-around);
  margin-right: auto;
  margin-left: 1.7125em;
  .r-logo {
    @include svg-fill($color-brand-accent);
    margin-right: 1.4375em;
  }
  .tab-name {
    line-height: 2.5625em;
    font-size: 2em;
    color: $font-primary;
    font-family: $semi-bold;
  }
}
.date-box {
  margin-right: 0.91em;
  margin-left: 1.325em;
}
.dateBoxHidden {
  margin-right: 1.5625em;
}
.toolbar {
  @include flex-center-justify;
  @include dropshadow-effect(0.16);
  background-color: $bg-tertiary;
  height: 3.5438em;
  //position: fixed;
}

.auto-refresh {
  @include dropshadow-effect(0.29);
  align-content: center;
  margin-bottom: 1.1875em;
  margin-top: 1.1875em;
  border-radius: 0.3125em;
  border: 0.0187em solid $border-primary;
}
.auto-refresh-content {
  text-align: center;
  color: $font-primary;
  line-height: 1.5em;
  font-size: 1em;
  width: 1.875em;
  height: 1.4375em;
  align-content: center;
  margin: 0.1875em;
  margin-left: 0.3125em;
  border: none;
  background-color: $bg-tertiary !important;
}
.auto-text {
  color: $font-primary;
}
.auto-refresh-text {
  width: 6.25em;
  height: 1.25em;
  font-size: 0.875em;
  line-height: 1.3125em;
  word-spacing: 0.0006em;
  color: $font-primary;
  cursor: pointer;
  border-radius: 0.25rem;
}
.auto-state {
  margin: 0rem 1.0625em;
  border-radius: 0.25em;
  line-height: 2.1875em;
}
.second {
  margin-left: 0.25em;
  font-size: 1.25em;
}
.refreshIcon {
  border-radius: 0.3125em;
  margin-top: 0.375em;
  cursor: pointer;
}

.topNotification {
  background-color: #f59600;
  height: fit-content;
}
.docs-view {
  margin-right: 0.7em;
  height: 2.3rem;
  width: auto;
  font-weight: bold;
}
.compare-date {
  margin-right: 1rem;
}
.disabled-overlay {
  position: relative;
  opacity: 0.5;
  pointer-events: none;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: all;
}
.lang-comp {
  margin-right: 1rem;
}
</style>
